module.exports = __webpack_public_path__ + "img/referto-5.70179f8f.webp";